import { handleDatetime, handleValue } from "./CustomTooltip";

const CustomizedAxisTick = ({ x, y, payload, axisName }) => {
  switch (axisName) {
    case "XAxis":
      return (
        <g>
          <text x={x} y={y} dx={-50} dy={10} fill="#666">
            {handleDatetime(payload.value, true)}
          </text>
        </g>
      );
    case "YAxis":
      return (
        <g>
          <text x={x} y={y} dy={4} fill="#666">
            {/* {handleValue(payload.value)} */}
            {payload.value}
          </text>
        </g>
      );
    default:
      break;
  }
};
export default CustomizedAxisTick;
